import { AuthenticationResult, Configuration, EventType, PublicClientApplication } from '@azure/msal-browser';

import { client } from '@af-fp/api/client.gen';

const config: Configuration = {
  auth: {
    clientId: '9c235ad3-381d-4a92-847f-c9b8f219aade',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: `${import.meta.env.VITE_FRONTEND_URL}/auth/login`,
  },
};

const loadStoredAccount = () => {
  const activeAccount = publicClientApplication.getActiveAccount();
  const allAccounts = publicClientApplication.getAllAccounts();

  if (!activeAccount && allAccounts.length > 0) {
    const account = allAccounts[0];
    publicClientApplication.setActiveAccount(account);
    console.info('Activated account', account.username);
  }
};

export const publicClientApplication = new PublicClientApplication(config);

const prepareMicrosoftOAuth = async () => {
  await publicClientApplication.initialize();
  loadStoredAccount();

  publicClientApplication.addEventCallback((event) => {
    if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
      const payload = event.payload as AuthenticationResult;
      client.setConfig({
        auth: payload.accessToken,
      });
    }

    if (event.eventType === EventType.LOGIN_SUCCESS) {
      loadStoredAccount();
    }
  });
};

void prepareMicrosoftOAuth();
